import { useEffect, useState } from "react";

/**
 * When an item mounts with defaultOpen, returns false until after paint so CSS
 * transitions (accordion body, header icon) do not run on first display.
 */
export function useAccordionTransitionEnabled(openedByDefault: boolean) {
  const [enabled, setEnabled] = useState(!openedByDefault);

  useEffect(() => {
    if (!openedByDefault) return;

    let raf1 = 0;
    let raf2 = 0;

    raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => {
        setEnabled(true);
      });
    });

    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
    };
  }, [openedByDefault]);

  return enabled;
}
